import { styled } from "goober";
import { useState } from "react";
import { PressButton } from "../PressButton";
import { Tooltip } from "../Tooltip";

// Mirrors the animated sidebar toggle (services/ui/components/Navigation.tsx):
// a panel outline with an inner rail whose width animates between open/closed.
// Flipped horizontally so the rail sits on the right, matching the output panel.
const ToggleOpener = styled(PressButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 9999px;
  color: var(--text-primary);
  cursor: pointer;
  &:hover {
    background: var(--alpha4);
  }
  & svg {
    transform: scaleX(-1);
  }
  & .inner {
    transition: width 180ms cubic-bezier(0.4, 0, 0.2, 1);
  }
  &[data-collapsed="true"] .inner {
    width: 1px;
  }
  &[data-collapsed="false"][data-preview="true"] .inner {
    width: 1px;
  }
  &[data-collapsed="true"][data-preview="true"] .inner {
    width: 4px;
  }
`;

type Props = {
  isOpen: boolean;
  onToggle: () => void;
};

export function OutputsToggleButton({ isOpen, onToggle }: Props) {
  const [hovered, setHovered] = useState(false);
  const [suppressed, setSuppressed] = useState(false);
  const label = isOpen ? "Hide outputs" : "Show outputs";
  return (
    <Tooltip
      content={
        <>
          {label}{" "}
          <span style={{ fontSize: 10, color: "var(--text-secondary)" }}>
            ⇧⌥O
          </span>
        </>
      }
    >
      <ToggleOpener
        aria-label={label}
        data-collapsed={!isOpen}
        data-preview={hovered && !suppressed}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => {
          setHovered(false);
          setSuppressed(false);
        }}
        onPress={() => {
          setSuppressed(true);
          onToggle();
        }}
      >
        <svg width="12" height="12" viewBox="0 0 16 16" fill="none">
          <path
            d="M11 2C12.6569 2 14 3.34315 14 5L14 11C14 12.6569 12.6569 14 11 14L6 14L5 14C3.34315 14 2 12.6569 2 11L2 5C2 3.34315 3.34315 2 5 2L6 2L11 2Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            className="inner"
            x="4"
            y="4"
            width="4"
            height="8"
            rx="1.5"
            fill="currentColor"
          />
        </svg>
      </ToggleOpener>
    </Tooltip>
  );
}
